export const normalizeVolume = (currentVolume: number, normalizedVolume: number = 0.6) => {
  return currentVolume > normalizedVolume ? normalizedVolume : currentVolume
}
